import { render, staticRenderFns } from "./StudioEquipment.vue?vue&type=template&id=5ffb64b6&"
import script from "./StudioEquipment.vue?vue&type=script&lang=js&"
export * from "./StudioEquipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports